export enum LiberationStatusEnum {
  WAITING = 'WAITING',
  ALLOWED = 'ALLOWED',
  DENIED = 'DENIED',
  DENIED_BY_CUSTOMER = 'DENIED_BY_CUSTOMER',
  EXPIRED = 'EXPIRED',
  WAITING_CUSTOMER = 'WAITING_CUSTOMER',
  CANCELED = 'CANCELED'
}
